import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useInitFoetalObservations = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ consultationId, pregnancyId }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/antenatalconsultationfoetalobservation/consultation/${consultationId}/pregnancy/${pregnancyId}/create-for-all-foetuses`
      );
      return response.data?.data ?? response.data;
    },
    onSuccess: (_, { consultationId }) => {
      queryClient.invalidateQueries({
        queryKey: ["foetalObservations", consultationId, localStorage.getItem("kinesin-tenant")],
      });
    },
    meta: { skipGlobalError: true },
  });
};
